import {
  FormPageProperty,
  FormPageProperties,
  SingleSelectionPropertyPulldown,
} from 'shared';
import {
  isSingleSelectionPropertyPulldown,
  isSingleSelectionPropertyPulldownWithDrillDown,
} from './typeGuard';

export type AssortedDrillDownPropertiesGroup =
  SingleSelectionPropertyPulldown[];
export type AssortedDrillDownProperties = AssortedDrillDownPropertiesGroup[];

const getPropertyPositionTuple = (
  sortedDrillDownProperties: AssortedDrillDownProperties,
  propertyId: FormPageProperty['propertyId']
): [number, number] | null => {
  const arrayIndex = sortedDrillDownProperties.findIndex((properties) =>
    properties.some((property) => property.propertyId === propertyId)
  );
  if (arrayIndex === -1) {
    return null;
  }
  const propertyIndex = sortedDrillDownProperties[arrayIndex].findIndex(
    (property) => property.propertyId === propertyId
  );
  return [arrayIndex, propertyIndex];
};

// 値を変更するのに親から順に見たいので、
// [[親 => 子 => 孫 => ひ孫], [親 => 子...] ...]
// の順番で分類する
export const assortDrillDownProperties = (
  properties: FormPageProperties
): AssortedDrillDownProperties => {
  const propertiesArray = Object.values(properties);
  const hasDrillDownProperty = propertiesArray.some((property) =>
    isSingleSelectionPropertyPulldownWithDrillDown(property)
  );
  if (!hasDrillDownProperty) {
    return [];
  }
  return propertiesArray
    .reduce<AssortedDrillDownProperties>((acc, childProperty) => {
      if (!isSingleSelectionPropertyPulldownWithDrillDown(childProperty)) {
        return acc;
      }
      const { drillDown } = childProperty;
      const parentProperty = properties[drillDown.parentId];
      if (!isSingleSelectionPropertyPulldown(parentProperty)) {
        return acc;
      }
      const parentPosition = getPropertyPositionTuple(
        acc,
        parentProperty.propertyId
      );

      const childPosition = getPropertyPositionTuple(
        acc,
        childProperty.propertyId
      );

      if (parentPosition && childPosition == null) {
        acc[parentPosition[0]].splice(parentPosition[1] + 1, 0, childProperty);
        return acc;
      }

      if (childPosition && parentPosition == null) {
        acc[childPosition[0]].splice(childPosition[1], 0, parentProperty);
        return acc;
      }

      if (parentPosition == null && childPosition == null) {
        return [...acc, [parentProperty, childProperty]];
      }

      if (
        parentPosition &&
        childPosition &&
        parentPosition[0] !== childPosition[0]
      ) {
        const descendants = acc[childPosition[0]].slice(childPosition[1]);
        acc[parentPosition[0]].splice(parentPosition[1] + 1, 0, ...descendants);
        acc[childPosition[0]].splice(childPosition[1]);
        return acc;
      }
      // parentPosition &&
      // childPosition &&
      // parentPosition[0] === childPosition[0]
      // になることはありえないので、ここは通らない
      return acc;
    }, [])
    .filter((group) => group.length);
};
